import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange,
        selectedCardsGroupsChange,
        toggleSwitch } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiChartGantt } from '@mdi/js';

import { _ } from '../../functions/translator'
import { ToggleActions } from '../../constants/constants.js';


class GanttChartDatesButton extends React.Component{
          
    showGanttChart = () => {
        this.props.toggleSwitch(ToggleActions.GANTT_CHART_DATES);
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={ this.showGanttChart }>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiChartGantt  } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Modificar fechas') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(GanttChartDatesButton)